import { useNavigate } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { XCircle } from "lucide-react";
import { useT, tr } from "@/lib/i18n";

export const PaymentCancel = () => {
  const navigate = useNavigate();
  useT();
  return (
    <div className="App">
      <Header />
      <div className="max-w-[720px] mx-auto px-6 py-20 text-center" data-testid="payment-cancel">
        <XCircle size={48} className="mx-auto" style={{ color: "var(--orange-spark)" }} />
        <h1 className="font-display text-3xl mt-4">{tr("Checkout cancelled", "Paiement annulé")}</h1>
        <p className="mt-2" style={{ color: "var(--muted)" }}>{tr("No charge was made. Your project is saved and you can unlock later.", "Aucun montant n'a été débité. Votre projet est enregistré et vous pourrez le déverrouiller plus tard.")}</p>
        <div className="mt-8 flex gap-3 justify-center">
          <button onClick={() => navigate("/projects")} className="btn-primary">{tr("My projects", "Mes projets")}</button>
          <button onClick={() => navigate("/configurator")} className="btn-secondary">{tr("New configuration", "Nouvelle configuration")}</button>
        </div>
      </div>
      <Footer />
    </div>
  );
};
